/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsChangePassword
 */
export interface MelcoModelsChangePassword {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsChangePassword
     */
    current_password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsChangePassword
     */
    new_password?: string | null;
}

export function MelcoModelsChangePasswordFromJSON(json: any): MelcoModelsChangePassword {
    return MelcoModelsChangePasswordFromJSONTyped(json, false);
}

export function MelcoModelsChangePasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsChangePassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current_password': !exists(json, 'current_password') ? undefined : json['current_password'],
        'new_password': !exists(json, 'new_password') ? undefined : json['new_password'],
    };
}

export function MelcoModelsChangePasswordToJSON(value?: MelcoModelsChangePassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_password': value.current_password,
        'new_password': value.new_password,
    };
}


